import { Component } from '@angular/core';
import { ListItemMenuContainerComponent } from '../../../../../shared/components/containers/list-item-menu-container/list-item-menu-container.component';
import { CustomerDeleteButtonComponent } from '../customer-delete-button/customer-delete-button.component';
import { CustomerStatusButtonComponent } from '../customer-status-button/customer-status-button.component';
import { BaseListItemMenuComponent } from '../../../../../shared/base-classes/base-list-item-menu.component';

@Component({
	selector: 'app-customers-list-item-menu',
	templateUrl: 'customers-list-item-menu.component.html',
	imports: [
		ListItemMenuContainerComponent,
		CustomerDeleteButtonComponent,
		CustomerStatusButtonComponent,
	],
})
export class CustomersListItemMenuComponent extends BaseListItemMenuComponent {}
